import { TenantEntity } from '../TenantEntity'

export class UsCustomsClearance extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'UsCustomsClearance'
  }
  get pdfType() {
    return this._data.pdfType
  }
  set pdfType(pdfType) {
    this._data.pdfType = pdfType
  }
  get dataType() {
    return this._data.dataType
  }
  set dataType(dataType) {
    if (typeof dataType === 'number') {
      this._data.dataType = dataType
    } else {
      this._data.dataType = 1
    }
  }
  get filerCode() {
    return this._data.filerCode
  }
  set filerCode(filerCode) {
    this._data.filerCode = filerCode
  }
  get entryType() {
    return this._data.entryType
  }
  set entryType(entryType) {
    this._data.entryType = entryType
  }
  get summaryDate() {
    return this._data.summaryDate
  }
  set summaryDate(summaryDate) {
    this._data.summaryDate = summaryDate
  }
  get code() {
    return this._data.code
  }
  set code(code) {
    this._data.code = code
  }
  get suretyNo() {
    return this._data.suretyNo
  }
  set suretyNo(suretyNo) {
    this._data.suretyNo = suretyNo
  }
  get bondType() {
    return this._data.bondType
  }
  set bondType(bondType) {
    this._data.bondType = bondType
  }
  get portCode() {
    return this._data.portCode
  }
  set portCode(portCode) {
    this._data.portCode = portCode
  }
  get entryDate() {
    return this._data.entryDate
  }
  set entryDate(entryDate) {
    this._data.entryDate = entryDate
  }
  get importingCarrier() {
    return this._data.importingCarrier
  }
  set importingCarrier(importingCarrier) {
    this._data.importingCarrier = importingCarrier
  }
  get modeOfTransport() {
    return this._data.modeOfTransport
  }
  set modeOfTransport(modeOfTransport) {
    this._data.modeOfTransport = modeOfTransport
  }
  get countryOfOrigin() {
    return this._data.countryOfOrigin
  }
  set countryOfOrigin(countryOfOrigin) {
    this._data.countryOfOrigin = countryOfOrigin
  }
  get importDate() {
    return this._data.importDate
  }
  set importDate(importDate) {
    this._data.importDate = importDate
  }
  get blAwbNo() {
    return this._data.blAwbNo
  }
  set blAwbNo(blAwbNo) {
    this._data.blAwbNo = blAwbNo
  }
  get manufacturerId() {
    return this._data.manufacturerId
  }
  set manufacturerId(manufacturerId) {
    this._data.manufacturerId = manufacturerId
  }
  get exportingCountry() {
    return this._data.exportingCountry
  }
  set exportingCountry(exportingCountry) {
    this._data.exportingCountry = exportingCountry
  }
  get exportDate() {
    return this._data.exportDate
  }
  set exportDate(exportDate) {
    this._data.exportDate = exportDate
  }
  get itNo() {
    return this._data.itNo
  }
  set itNo(itNo) {
    this._data.itNo = itNo
  }
  get itDate() {
    return this._data.itDate
  }
  set itDate(itDate) {
    this._data.itDate = itDate
  }
  get missingDocs() {
    return this._data.missingDocs
  }
  set missingDocs(missingDocs) {
    this._data.missingDocs = missingDocs
  }
  get foreignPortOfLading() {
    return this._data.foreignPortOfLading
  }
  set foreignPortOfLading(foreignPortOfLading) {
    this._data.foreignPortOfLading = foreignPortOfLading
  }
  get usPortOfUnlading() {
    return this._data.usPortOfUnlading
  }
  set usPortOfUnlading(usPortOfUnlading) {
    this._data.usPortOfUnlading = usPortOfUnlading
  }
  get locationOfGoods() {
    return this._data.locationOfGoods
  }
  set locationOfGoods(locationOfGoods) {
    this._data.locationOfGoods = locationOfGoods
  }
  get choose() {
    return this._data.choose
  }
  set choose(choose) {
    this._data.choose = choose
  }
  get code2() {
    return this._data.code2
  }
  set code2(code2) {
    this._data.code2 = code2
  }
  get consigneeNo() {
    return this._data.consigneeNo
  }
  set consigneeNo(consigneeNo) {
    this._data.consigneeNo = consigneeNo
  }
  get importerNo() {
    return this._data.importerNo
  }
  set importerNo(importerNo) {
    this._data.importerNo = importerNo
  }
  get referenceNo() {
    return this._data.referenceNo
  }
  set referenceNo(referenceNo) {
    this._data.referenceNo = referenceNo
  }
  get ultimateConsigneeNameAndAddress() {
    return this._data.ultimateConsigneeNameAndAddress
  }
  set ultimateConsigneeNameAndAddress(ultimateConsigneeNameAndAddress) {
    this._data.ultimateConsigneeNameAndAddress = ultimateConsigneeNameAndAddress
  }
  get address() {
    return this._data.address
  }
  set address(address) {
    this._data.address = address
  }
  get addressDetail() {
    return this._data.addressDetail
  }
  set addressDetail(addressDetail) {
    this._data.addressDetail = addressDetail
  }
  get destination() {
    return this._data.destination
  }
  set destination(destination) {
    this._data.destination = destination
  }
  get customerReference() {
    return this._data.customerReference
  }
  set customerReference(customerReference) {
    this._data.customerReference = customerReference
  }
  get city() {
    return this._data.city
  }
  set city(city) {
    this._data.city = city
  }
  get state() {
    return this._data.state
  }
  set state(state) {
    this._data.state = state
  }
  get zip() {
    return this._data.zip
  }
  set zip(zip) {
    this._data.zip = zip
  }
  get importerOfRecordNameAndAddress() {
    return this._data.importerOfRecordNameAndAddress
  }
  set importerOfRecordNameAndAddress(importerOfRecordNameAndAddress) {
    this._data.importerOfRecordNameAndAddress = importerOfRecordNameAndAddress
  }
  get address2() {
    return this._data.address2
  }
  set address2(address2) {
    this._data.address2 = address2
  }
  get addressDetail2() {
    return this._data.addressDetail2
  }
  set addressDetail2(addressDetail2) {
    this._data.addressDetail2 = addressDetail2
  }
  get city2() {
    return this._data.city2
  }
  set city2(city2) {
    this._data.city2 = city2
  }
  get state2() {
    return this._data.state2
  }
  set state2(state2) {
    this._data.state2 = state2
  }
  get zip2() {
    return this._data.zip2
  }
  set zip2(zip2) {
    this._data.zip2 = zip2
  }
  get totalQuantity() {
    return this._data.totalQuantity
  }
  set totalQuantity(totalQuantity) {
    this._data.totalQuantity = totalQuantity
  }
  get unit() {
    return this._data.unit
  }
  set unit(unit) {
    this._data.unit = unit
  }
  get signatureDate() {
    return this._data.signatureDate
  }
  set signatureDate(signatureDate) {
    this._data.signatureDate = signatureDate
  }
  get generatingFileMergeSameProduct() {
    return this._data.generatingFileMergeSameProduct
  }
  set generatingFileMergeSameProduct(generatingFileMergeSameProduct) {
    this._data.generatingFileMergeSameProduct = generatingFileMergeSameProduct || false
  }
  get showTax() {
    return this._data.showTax
  }
  set showTax(showTax) {
    this._data.showTax = showTax || false
  }
  get showChinaSurtax() {
    return this._data.showChinaSurtax
  }
  set showChinaSurtax(showChinaSurtax) {
    this._data.showChinaSurtax = showChinaSurtax || false
  }
  get showBond() {
    return this._data.showBond
  }
  set showBond(showBond) {
    this._data.showBond = showBond || false
  }
  get bondAmount() {
    return this._data.bondAmount
  }
  set bondAmount(bondAmount) {
    this._data.bondAmount = bondAmount || 0
  }
  get totalPack() {
    return this._data.totalPack
  }
  set totalPack(totalPack) {
    this._data.totalPack = totalPack || 0
  }
  get totalNetWeight() {
    return this._data.totalNetWeight
  }
  set totalNetWeight(totalNetWeight) {
    this._data.totalNetWeight = totalNetWeight || 0
  }
  get totalGrossWeight() {
    return this._data.totalGrossWeight
  }
  set totalGrossWeight(totalGrossWeight) {
    this._data.totalGrossWeight = totalGrossWeight || 0
  }
  get totalVolume() {
    return this._data.totalVolume
  }
  set totalVolume(totalVolume) {
    this._data.totalVolume = totalVolume || 0
  }
  get totalNumber() {
    return this._data.totalNumber
  }
  set totalNumber(totalNumber) {
    this._data.totalNumber = totalNumber || 0
  }
  get totalCargoValue() {
    return this._data.totalCargoValue
  }
  set totalCargoValue(totalCargoValue) {
    this._data.totalCargoValue = totalCargoValue || 0
  }
  get totalTariff() {
    return this._data.totalTariff
  }
  set totalTariff(totalTariff) {
    this._data.totalTariff = totalTariff || 0
  }
  get totalFee056() {
    return this._data.totalFee056
  }
  set totalFee056(totalFee056) {
    this._data.totalFee056 = totalFee056 || 0
  }
  get totalFee499() {
    return this._data.totalFee499
  }
  set totalFee499(totalFee499) {
    this._data.totalFee499 = totalFee499 || 0
  }
  get totalFee501() {
    return this._data.totalFee501
  }
  set totalFee501(totalFee501) {
    this._data.totalFee501 = totalFee501 || 0
  }
  get totalChinaAdditionalRate() {
    return this._data.totalChinaAdditionalRate
  }
  set totalChinaAdditionalRate(totalChinaAdditionalRate) {
    this._data.totalChinaAdditionalRate = totalChinaAdditionalRate || 0
  }
  get otherTotalCharge() {
    return this._data.otherTotalCharge
  }
  set otherTotalCharge(otherTotalCharge) {
    this._data.otherTotalCharge = otherTotalCharge || 0
  }
  get total() {
    return this._data.total
  }
  set total(total) {
    this._data.total = total || 0
  }
  get usCustomsClearanceCargoList() {
    return this._data.usCustomsClearanceCargoList
  }
  set usCustomsClearanceCargoList(usCustomsClearanceCargoList) {
    this._data.usCustomsClearanceCargoList = usCustomsClearanceCargoList
  }
  get jobUuid() {
    return this._data.jobUuid
  }
  set jobUuid(jobUuid) {
    this._data.jobUuid = jobUuid
  }
  get relatedUsCustomsClearance() {
    return this._data.relatedUsCustomsClearance
  }
  set relatedUsCustomsClearance(relatedUsCustomsClearance) {
    this._data.relatedUsCustomsClearance = relatedUsCustomsClearance
  }
}
